import axios from 'axios';
import { useEffect, useState } from 'react';
import { Loading } from '@/shared/components/export';
import { Button, FormSelect, InputGroup, Tab, Tabs } from 'react-bootstrap';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AgedDateFormat } from '@/core/date/export';

async function runQ(s: string) {
  return (
    await axios.post('https://sfkdzh76htt33ga5f4v5ci5xt40umiah.lambda-url.us-east-1.on.aws/', {
      message: {
        text: s,
      },
    })
  ).data;
}

export default function Assistant() {
  const [query, setQuery] = useState<string>('Whats happening today?');
  const [result, setResult] = useState<any>();
  const [html, setHtml] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [bibliography, setBibliography] = useState<string>('');
  const [dateUpdated, setDateUpdated] = useState<Date>();

  const refresh = (q: string) => {
    setResult('');
    setLoading(true);
    setHtml('');
    setQuery(q);
    runQ(q)
      .then(setResult)
      .catch(setResult)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refresh(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDateUpdated(new Date());
    console.log(result);
    if (result?.cardsV2 && result.cardsV2.length > 0) {
      const card = result.cardsV2[0];

      console.log('Card', card);

      if (card.card?.sections && card.card.sections.length > 0) {
        const section = card.card.sections[0];

        console.log('Section', section);

        if (section.widgets && section.widgets.length > 0) {
          const widget = section.widgets[0];

          setHtml(widget.textParagraph.text.replaceAll('\n', '<br/>'));
        }

        if (section.widgets) {
          section.widgets.forEach((w: any) => {
            if (w?.textParagraph?.text?.includes('Sources')) {
              setBibliography(w.textParagraph.text.replaceAll('\n', '<br/>'));
            }
          });
        }
      }
    }
  }, [result]);

  return (
    <div className={'d-flex flex-column h-100'}>
      <div className={'flex-fill overflow-auto h-100'}>
        <InputGroup className={'mb-2'}>
          <FormSelect onChange={event => refresh(event.target.value)} size={'sm'}>
            <option selected={true}>Whats happening today?</option>
            <option>Whats happening in oil?</option>
            <option>Whats happening in FX?</option>
            <option>Whats happening in Policy?</option>
            <option>Whats happening in Credit?</option>
          </FormSelect>
          <Button size={'sm'} variant={'tertiary'} onClick={() => refresh(query)}>
            <FontAwesomeIcon icon={faRotateRight} />
          </Button>
        </InputGroup>

        {dateUpdated && (
          <div className={'small mb-2'}>
            Last Update: <AgedDateFormat format={'D/MM h:mm a'} date={dateUpdated} />
          </div>
        )}

        {loading && <Loading />}
        {!loading && (
          <Tabs className={'sticky-top bg-body'}>
            <Tab title={'Summary'} eventKey={'summary'} className={' h-100 overflow-auto'}>
              <div
                className={'h-100 overflow-auto p-2'}
                dangerouslySetInnerHTML={{ __html: html }}
              ></div>
            </Tab>
            <Tab title={'Links'} eventKey={'links'}>
              <div
                className={'p-2 h-100 overflow-auto'}
                dangerouslySetInnerHTML={{ __html: bibliography }}
              ></div>
            </Tab>
          </Tabs>
        )}
      </div>
    </div>
  );
}
